import { SpaceBetween, Toggle } from "@cloudscape-design/components";
import { Mode, Density } from "@cloudscape-design/global-styles";
import * as awsui from "@cloudscape-design/design-tokens";
import { Navbar, Dropdown, Spacer } from "@nextui-org/react"; // https://nextui.org/docs/components/navbar
import { Layout } from "./layout";
import { HamburgerIcon, SettingsIcon, icons } from "./icons";
import headerLogoLight from "../../images/frg-header-logo-light.png";
import headerLogoDark from "../../images/frg-header-logo-dark.png";
import { GlobalContext } from "../../context";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import { NextUIProvider } from "@nextui-org/react"
import { nextUiTheme } from "../../theme";
import { useMediaQuery } from 'react-responsive';
import SeriesNavLinks from './series-navbar-links';
import AccountNavLinks from './account-navbar-links';



export default function SeriesNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { 
    theme, setTheme,
    density, setDensity,
  } = useContext(GlobalContext);
  

  const NavLinks = () => {
    if (location.pathname === "/account") return <AccountNavLinks />

    return <SeriesNavLinks />
  }

  return (
    <>
    <NextUIProvider theme={nextUiTheme}>
        <Layout>
          <Navbar 
            variant="static" 
            {...density === Density.Comfortable ? {isCompact:false} : {isCompact:true}}
            css={{ background: "none", boxShadow: "none", fontSize: "18px"}}
          >
            <Navbar.Brand />
            <Navbar.Content
              activeColor="primary"
              // hideIn="xs"
              variant="underline"
            >
              <NavLinks />
            </Navbar.Content>
            <SpaceBetween direction="horizontal" size="l">
              {/* <Navbar.Content /> */}
            </SpaceBetween>
          </Navbar>
        </Layout>
      </NextUIProvider>
    </>
  );
}
